import { makeHeadingPropsSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const titleSelector = getSettingValueSelector(TargetSelector.Entity, "title", "popup.heading");
  const headingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity, "popup.heading") as any;
  const headingHorizontalAlignSelector = getSettingValueSelector(
    TargetSelector.Entity,
    "horizontalAlign",
    "popup.heading"
  );

  return (state: AppState, props: RootContainerProps): MapProps & WithIsVisibleHOCProps => {
    const title = titleSelector(state, props);
    return {
      ...props,
      isVisible: !!title,
      horizontalAlign: headingHorizontalAlignSelector(state, props),
      headingProps: headingPropsSelector(state, props),
      title
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
